export const CssIdentifierRegex = '^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$';
